import { cn } from '@lib/utils';
import React from 'react';

type NumberBadgeSize = 'sm' | 'md';

type NumberBadgeProps = {
  className?: string;
  size?: NumberBadgeSize;
  value: number | string;
};

const sizeStyles: Record<NumberBadgeSize, string> = {
  md: 'px-2 min-w-9 text-xl',
  sm: 'px-1.5 min-w-7 text-lg',
};

export const NumberBadge: React.FC<NumberBadgeProps> = (props) => {
  const { className, size = 'sm', value } = props;

  return (
    <div
      className={cn(
        'flex items-center justify-center font-semibold text-[#3D2EFF] bg-[#3D2EFF1A] rounded-sm',
        sizeStyles[size],
        className,
      )}
    >
      {value}
    </div>
  );
};
